const UserTockem = 'TockemUsuario'

const isLogged = () => !!localStorage.getItem(UserTockem)

export {UserTockem, isLogged}